 // components/Projects.jsx
import React from 'react';
import './Projects.css';

const projects = [
  {
    title: 'RealEstate Website',
    image: require('../assets/RealEstate.png'),
    description: 'Our project, All Is Well Eco Ventures RealEstate Portal, is a dynamic web platform that showcases DTCP-approved open plots with rich visuals, gallery, and location details. It enables users to explore property listings, view photos/videos, and easily connect or navigate to the site.',
    tech: ['HTML', 'CSS', 'JavaScript', 'PHP'],
    github: 'https://github.com/TEJAPRAVEENDEVARAJU/RealEstate',
    // demo: 'https://all-is-well.free.nf/',
  },
  {
    title: 'Tourism',
    image: require('../assets/tourism.png'),
    description: 'Our Tourism Booking Website is a one-stop platform where users can seamlessly book tickets to various tourist destinations through a secure payment gateway. It simplifies travel planning by consolidating all bookings in one place with instant receipt downloads.',
    tech: ['HTML', 'Bootstrap', 'FontAwesome','PHP','MySql'],
    github: 'https://github.com/TEJAPRAVEENDEVARAJU/tourism',
    // demo: 'https://your-todo-app.vercel.app',
  },
  {
    title: 'College Department Website',
    image: require('../assets/department.png'),
    description: 'Our project is an online examination portal that allows students to securely attend randomized MCQ-based exams with time limits and activity restrictions. It includes an admin panel for managing questions, students, and exam settings, with CSV user generation and result tracking.',
    tech: ['HTML', 'Bootstrap', 'FontAwesome','PHP','MySql'],
    github: 'https://github.com/TEJAPRAVEENDEVARAJU/Department_WebSite',
    // demo: 'https://department.42web.io/',
  },
   {
    title: 'Lossless Compression Of JPEG photos',
    image: require('../assets/Interface.png'),
    description: 'Our project presents a Hybrid JPEG Compression method that enhances compression efficiency for JPEG photo collections by exploiting inter-image redundancies using SIFT-based feature matching and MST prediction structures. It significantly outperforms traditional and individual JPEG recompression methods by applying spatial disparity compensation and frequency-domain residual coding.',
    tech: ['Matlab'],
    github: 'https://github.com/TEJAPRAVEENDEVARAJU/Lossless_Compression_Jpeg#',
    demo: '',
  },
];


export default function Projects() {
  return (
    <section className="glass" id="projects">
      <h2>Projects</h2>
      <div className="projects-grid">
  {projects.map((proj, index) => (
    <div className="project-card" key={index}>
      <img src={proj.image} alt={proj.title} className="project-img" />
      <h3>{proj.title}</h3>
      <p className="project-description">{proj.description}</p>
      <div className="project-tech">
        {proj.tech.map((techItem, i) => (
          <span key={i} className="tech-badge">{techItem}</span>
        ))}
      </div>
      <div className="project-links">
        {proj.demo && (
          <a href={proj.demo} target="_blank" rel="noreferrer" className="btn-sm">Live</a>
        )}
        <a href={proj.github} target="_blank" rel="noreferrer" className="btn-sm outline">
          GitHub
        </a>
      </div>
    </div>
  ))}
</div>

    </section>
  );
}
